// DML add/remove planners: add/remove INSERT VALUES rows and add/remove UPDATE
// assignments. Each op is a comma-separated list edit, so we reuse the generic
// `planListInsert` / `planListRemove` helpers from applyStructuralEdit.lists.
//
// PRD: Ralph/SemanticResolverEdit/PRD.md § Slice: Round-Trip Corpus
// (closes the four DML add/remove ops listed in `applyStructuralEdit.ts:93`).

import type { PlannedByteEdit, StructuralEdit } from '../types';

import type { EditCtx } from './applyStructuralEdit';
import { planListInsert, planListRemove } from './applyStructuralEdit.lists';
import type { ListItem } from './applyStructuralEdit.shared';

// INSERT VALUES rows -------------------------------------------------------

export function planInsertValuesRowEdit(
  ctx: EditCtx,
  edit: Extract<StructuralEdit, { op: 'add-insert-values-row' | 'remove-insert-values-row' }>,
): readonly PlannedByteEdit[] {
  const ranges = ctx.structure.insertValueRowRanges ?? [];
  const items: ListItem[] = ranges.map((range) => ({ range }));
  if (edit.op === 'add-insert-values-row') {
    if (items.length === 0) return [];
    const text = `(${edit.values.join(', ')})`;
    return [planListInsert(ctx, items, text, undefined, 'add-insert-values-row')];
  }
  const planned = planListRemove(ctx, items, edit.index, 'remove-insert-values-row');
  return planned ? [planned] : [];
}

// UPDATE assignments -------------------------------------------------------

export function planUpdateAssignmentAddRemove(
  ctx: EditCtx,
  edit: Extract<StructuralEdit, { op: 'add-update-assignment' | 'remove-update-assignment' }>,
): readonly PlannedByteEdit[] {
  const items = ctx.structure.updateAssignments ?? [];
  if (edit.op === 'add-update-assignment') {
    if (items.length === 0) return [];
    const text = `${edit.target} = ${edit.valueText}`;
    return [planListInsert(ctx, items, text, undefined, 'add-update-assignment')];
  }
  const planned = planListRemove(ctx, items, edit.index, 'remove-update-assignment');
  return planned ? [planned] : [];
}
